import { apiConfigApi } from "@/service/client";
import { ApiConfigModel } from "@/shared/model/api-config.model";
import { curlToJson } from "@/shared/utils/curl.utils";
import { useQuery, useQueryClient } from "@tanstack/react-query";

export const useApiConfigController = () => {
  const queryClient = useQueryClient();

  const { data: apiConfigList, isLoading } = useQuery({
    queryKey: ["api-config"],
    queryFn: async () => {
      const response = await apiConfigApi.getApiConfigList();
      return response ?? null;
    },
  });

  const createApiConfig = async ({
    name,
    url,
    curlRaw,
  }: {
    name: string;
    url?: string;
    curlRaw?: string;
  }): Promise<ApiConfigModel> => {
    const trimName = name.trim();
    const trimUrl = url?.trim();
    const trimCurlRaw = curlRaw?.trim();

    if (!trimName) {
      throw new Error("Name is required");
    }

    if (!trimCurlRaw && !trimUrl) {
      throw new Error("Curl command or URL is required");
    }

    const apiConfig = await apiConfigApi.createApiConfig({
      name: trimName,
      url: trimUrl,
      curl_json: trimCurlRaw ? curlToJson(trimCurlRaw) : undefined,
    });

    queryClient.invalidateQueries({ queryKey: ["api-config"] });

    return apiConfig;
  };

  return {
    apiConfigList,
    isLoading,
    createApiConfig,
  };
};
